import React, {useContext} from "react";
import {CreateDeliveryContext} from "../CreateDeliveryRequest";
import {useTranslation} from "react-i18next";
import {FormHeader, SubmitDeliveryButton} from "./DeliveryRequestForm.styles";
import {FormContainer} from "./DeliveryRequestForm.styles";
import {PickupInformation} from "./pickupInformation/PickupInformation";
import {OrderInformation} from "./orderInformation/OrderInformation";

export const DeliveryRequestForm = () => {
    const {t} = useTranslation(["newRequest"]);
    const {submitDelivery} = useContext(CreateDeliveryContext);

    return (
        <>
            <FormContainer>
                <FormHeader>{t("screens.newRequest", {ns: "common"})}</FormHeader>
                <PickupInformation />
                <OrderInformation/>
                <SubmitDeliveryButton type="primary" onClick={() => submitDelivery()}>
                    {t("newRequest.actions.createDelivery", {ns: "newRequest"})}
                </SubmitDeliveryButton>
            </FormContainer>
        </>
    );
};
